/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.pages.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.posConfig',
  'acme.common.directive.posPage',
  'acme.view.application.pos.create.pages.deleteTileModal.controllers'
])

.controller('PosCreatePagesController', ['$scope', '$state', '$uibModal', '$timeout', '$q', 'ApiService', 'PosConfigService', function($scope, $state, $uibModal, $timeout, $q, ApiService, PosConfigService) {

    $scope.posCreatePages = {

      model: {
        rows: 5,
        columns: 4,
        page: {},
        pages: []
      },

      sortableOptions: {

        axis: 'y',

        update: function(e, ui) {
          $scope.posCreatePages.onSortableUpdate(e, ui);
        }

      },

      removeDialog: {},

      init: function () {
        $scope.$on('PosTile::Select', this.onPosTileSelect);
        $scope.$on('PosTile::Move', this.onPosTileMove);
        $scope.$on('PosTile::Swap', this.onPosTileMove);
        $scope.$on('PosNavigation::Select', this.onPosNavigationSelect);
        $scope.$on('PosCreateController::UpdateModel', this.onPosCreateUpdateModel);
        $scope.$on('PosCreatePagesFormsController::UpdateTile', this.onPosCreatePagesFormsControllerUpdateTile);
        $scope.$on('PosCreatePagesFormsController::RemoveTile', this.onPosCreatePagesFormsControllerRemoveTile);
        $scope.$on('PosCreatePagesFormsPageController::RemovePage', this.onPosCreatePagesFormsPageControllerRemovePage);
        $scope.$on('PosCreatePagesFormsPageController::UpdatePage', this.onPosCreatePagesFormsPageControllerUpdatePage);

        PosConfigService.pages.clearDefaultPage();
        PosConfigService.pages.clearSelectedPage();

        this.getModel();
      },
      
      getModel: function() {
        this.model.pages = PosConfigService.pages.getModel();

        if (this.model.pages instanceof Array && this.model.pages.length) {
          PosConfigService.pages.setDefaultPage(this.model.pages[0].pageId);
          this.selectPage(PosConfigService.pages.getDefaultPageId());
        }
      },

      createPage: function() {
        var page = PosConfigService.pages.create();
        this.model.pages = PosConfigService.pages.getModel();
        this.selectPage(page.pageId);
        $scope.$emit('PosCreatePagesController::Update');
      },

      isSelected: function (id) {
        return (id === PosConfigService.pages.getSelectedPageId());
      },

      selectPage: function (id, force) {
        var found;

        if (id !== PosConfigService.pages.getSelectedPageId() || force) {

          PosConfigService.pages.setSelectedPage(id);
          found = PosConfigService.pages.getSelectedPage();

          if (found) {
            // Strip all empty tiles
            found.page.items = PosConfigService.tiles.process(found.page.items);
            this.model.page = found.page;

            //this.checkPageItemErrors(found.page.items);

            $timeout( function() {
              $scope.$broadcast('PosCreatePagesController::Select', found.page);
              $scope.$broadcast('PosNavigation::Update');
            }, 0);
          }

        }

      },

      getTemplate: function(id, configId){
        var found;
        if (id && configId) {
          ApiService.program.get(id, false, true).then(function(response){
            found = PosConfigService.tiles.findTile(configId);
            if (found) {
              found.tile.hasError = false;
              PosConfigService.tiles.setTile(found.tile);
            }
          }, function(response){
            found = PosConfigService.tiles.findTile(configId);
            if (found) {
              found.tile.hasError = true;
              PosConfigService.tiles.setTile(found.tile);
            }
          });
        }
      },

      checkPageItemErrors: function(item) {
        if (item && item.config && (item.config.type === 'standard' || item.config.type === 'generalAdmission')) {
          $scope.posCreatePages.getTemplate(item.id, item.config.id);
        }
      },

      isPrimary: function(id) {
        return (id === PosConfigService.pages.getDefaultPageId());
      },

      selectPrimaryPage: function(id) {
        PosConfigService.pages.setDefaultPage(id);
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onSortableUpdate: function(e, data) {
        var self = $scope.posCreatePages;

        $timeout(function() {
          var i, ii;

          PosConfigService.pages.updateOrder();
          self.model.pages = PosConfigService.pages.getModel();

          for (i=0, ii=self.model.pages.length; i < ii; i++) {
            PosConfigService.updateNavigationTiles(self.model.pages[i].pageId);
          }
          $scope.$emit('PosCreatePagesController::Update');
        }, 0);
      },

      onPosTileSelect: function(e, data) {
        $scope.$broadcast('PosCreatePagesController::SelectTile', data);
      },

      onPosTileMove: function(e, data) {
        $scope.$emit('PosCreatePagesController::Update');
      },

      onPosNavigationSelect: function(e, data) {
        var self = $scope.posCreatePages;
        self.selectPage(data.pageId);
      },

      onPosCreateUpdateModel: function(e, data) {
        var self = $scope.posCreatePages;
        PosConfigService.images.setModel(PosConfigService.images.getModel());

        PosConfigService.pages.clearDefaultPage();
        PosConfigService.pages.clearSelectedPage();

        self.getModel();
      },

      onPosCreatePagesFormsControllerUpdateTile: function(e, data) {
        var self = $scope.posCreatePages;
        self.model.pages = PosConfigService.pages.getModel();

        //next tick
        $timeout(function() {
          self.model.page = PosConfigService.pages.getSelectedPage().page;
          $scope.$emit('PosCreatePagesController::Update');
        }, 0);
      },

      onPosCreatePagesFormsControllerRemoveTile: function(e, data) {
        var self = $scope.posCreatePages;

        self.removeDialog = $uibModal.open({
          templateUrl: 'views/application/views/pos/create/pages/modals/deleteTileModal.tpl.html',
          size: 'md',
          controller: 'PosCreatePagesDeleteTileModalController',
          resolve: {
            tile: function() {
              return data;
            }
          }
        });

        self.removeDialog.result.then(function () {
          PosConfigService.tiles.removeTile(data);
          PosConfigService.pages.getSelectedPage().page.items = PosConfigService.tiles.getModel();

          self.selectPage(PosConfigService.pages.getSelectedPage().page.pageId, true);
          
          $scope.$broadcast('PosTile::Remove');
          $scope.$emit('PosCreatePagesController::Update');
        }, function() {
          // do nothing});
        });

      },

      onPosCreatePagesFormsPageControllerRemovePage: function(e, data) {
        var self = $scope.posCreatePages,
            pages = PosConfigService.pages.getModel();

        if (pages.length > 1) {
          PosConfigService.pages.remove(data.pageId);
          PosConfigService.updateRemovedPageTiles(PosConfigService.getRemovedPageTiles());
          PosConfigService.relinkNavigationTilesAfterPageDeletion(data.pageId);
          self.selectPage(pages[0].pageId);
          $scope.$emit('PosCreatePagesController::Update');
        }
      },

      onPosCreatePagesFormsPageControllerUpdatePage: function(e, data) {
        PosConfigService.pages.updatePage(data);
        PosConfigService.updateNavigationTiles(data.pageId);
        $scope.$emit('PosCreatePagesController::Update');
      }

    };

    $scope.posCreatePages.init();

}]);
